// extracted by mini-css-extract-plugin
export default {"unit":"8px","colorPrimaryYellow":"#FDBC22","starIcon":"XsCGxmpsCzxryvtg1Egw","halfStar":"lID_KA7AAqwC7405RVk8","xs":"xnNOF6So38vQrawO4lBE","ratingSection":"cXsmrXrvi2YFSrYYU34R"};